<div *ngIf="shop_notification !== null && shop_notification?.enabled" class="msg-box ion-text-center" [style.background-color]="shop_notification?.bg_color">
  <button (click)="disableNotification()" class="close-btn" [style.background-color]="shop_notification?.bg_color" [style.color]="shop_notification?.text_color">
    <ion-icon name="close" class="close-icon"></ion-icon>
  </button>
  <p class="font-14 pre-wrap" [style.color]="shop_notification?.text_color">{{ shop_notification?.message }}</p>
</div>